export default class Masks {
  dataFriendlyFromSql = (sqlDate) => {

    if(!sqlDate){ return ''}
    
    let substractedDate = sqlDate.substring(0, 10);
    let sp = substractedDate.split("-");
    if (!sp) {
      throw new Error(`Data sql ${sqlDate} este in format incorect`);
    }

    let an = sp[0];
    let luna = sp[1];
    let ziua = sp[2];

    let ziuaCurenta = new Date();
    let anCurent = ziuaCurenta.getFullYear();
    let lunaCurenta = ziuaCurenta.getMonth();
    let dayCurent = ziuaCurenta.getDate();

    let dataFromSql = new Date(an, luna - 1, ziua);
    let dataActuala = new Date(anCurent, lunaCurenta, dayCurent);

    //console.log("Comparing dates:today is :  ", dataActuala, "si data sql este: ", dataFromSql)

    if (dataFromSql == dataActuala) {
      return "Astazi";
    } else {
      let ieri = new Date(anCurent, lunaCurenta, dayCurent);
      ieri.setDate(ieri.getDate() - 1);

      //console.log("Comparing dates: ieri is :  ", ieri, "si data sql este: ", dataFromSql)

      if (dataFromSql == ieri) {
        return "Ieri";
      } else {
        let maine = new Date(anCurent, lunaCurenta, dayCurent);
        maine.setDate(maine.getDate() + 1);

        //console.log("Comparing dates: maine is :  ", maine, "si data sql este: ", dataFromSql)

        if (dataFromSql == maine) {
          return "Maine";
        } else {
          let luni = [
            "Ian",
            "Feb",
            "Mar",
            "Apr",
            "Mai",
            "Iun",
            "Iul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];

          return (
            this.dayOfWeek(dataFromSql.getDay()) +
            " " +
            dataFromSql.getDate() +
            " " +
            luni[dataFromSql.getMonth()] +
            " " +
            dataFromSql.getFullYear()
          );
        }
      }
    }
  }; // end func

  dateTimeFriendlyFromSql = (dataFromSql) => {
    let dataFriendly = this.dataFriendlyFromSql(dataFromSql);

    let time = dataFromSql.split("T");
    if (!time[1]) {
      throw new Error("Time is not in the correct format !");
    }
    let fTime = time[1];

    return dataFriendly + " " + fTime.substring(0, 5);
  };

  curentDateToDateField = () => {
    // yyyy-MM-dd
    let cur = new Date();
    let an = cur.getFullYear();
    let luna = cur.getMonth() + 1;
    let ziua = cur.getDate();

    let ziuaAsString = String(ziua).length == 1 ? `0${ziua}` : String(ziua);
    let lunaAsString = String(luna).length == 1 ? `0${luna}` : String(luna);

    return an + "-" + lunaAsString + "-" + ziuaAsString;
  };

  specificDateToDateField = (dt) => {
    // yyyy-MM-dd
    let cur = new Date(dt);
    let an = cur.getFullYear();
    let luna = cur.getMonth() + 1;
    let ziua = cur.getDate();

    let ziuaAsString = String(ziua).length == 1 ? `0${ziua}` : String(ziua);
    let lunaAsString = String(luna).length == 1 ? `0${luna}` : String(luna);

    return an + "-" + lunaAsString + "-" + ziuaAsString;
  };

  addDaysToDateAndConvertToField = (dt, nrZile) => {
    var result = new Date(dt);
    result.setDate(result.getDate() + nrZile);

    return this.specificDateToDateField(result);
  };

  dayOfWeek = (dayNr) => {
    let dayName = "";

    switch (String(dayNr)) {
      case "0":
        dayName = "Duminica";
        break;
      case "1":
        dayName = "Luni";
        break;
      case "2":
        dayName = "Marti";
        break;
      case "3":
        dayName = "Miercuri";
        break;
      case "4":
        dayName = "Joi";
        break;
      case "5":
        dayName = "Vineri";
        break;
      case "6":
        dayName = "Sambata";
        break;
      default:
        dayName = "fara zi";
    }

    return dayName;
  };

  fistDayMonth = (dt) => {
    let cur = dt;
    let an = cur.getFullYear();
    let luna = cur.getMonth() + 1;
    let ziua = "01";
    let lunaAsString = String(luna).length == 1 ? `0${luna}` : String(luna);
    return an + "-" + lunaAsString + "-" + ziua;
  };

  function(y,m){
    return  new Date(y, m +1, 0).getDate();
    }

  lastDayMonth = (dt) => {
    let cur = dt;
    let an = cur.getFullYear();
    let luna = cur.getMonth() + 1;

    // console.log('luna :>> ', luna);

    let ziua = new Date(an, luna, 0).getDate();

    let lunaAsString = String(luna).length == 1 ? `0${luna}` : String(luna);
    return an + "-" + lunaAsString + "-" + ziua;
  };

  addMonthsToDate = (dt, nrLuni) => {
    var newDate = new Date(dt.setMonth(dt.getMonth() + nrLuni));
    return newDate;
  };

  addDaysToDate = (dt, nrZile) => {
    var result = new Date(dt);
    result.setDate(result.getDate() + nrZile);

    return result;
  };

  sqlDateToJSDate = (sqlDate) => {
    // console.log('time to convert', sqlDate)
    if (!sqlDate) {
      console.error("Err: sql date is null ??");
      return null;
    }

    if (sqlDate.indexOf("-") == -1) {
      console.error("Err: sql date without - separator ??");
      return null;
    }

    // daca e datetime
    if (sqlDate.indexOf("T") == -1) {
      let ds = sqlDate.split("-");

      let asDate = new Date(ds[0], ds[1] - 1, ds[2]);
      return asDate;
    } else {
      let sp = sqlDate.split("T");
      let ds = sp[0].split("-");

      let asDate = new Date(ds[0], ds[1] - 1, ds[2]);
      return asDate;
    }
  };

  jsDatesDifferenceInDays = (dt1, dt2) => {
    const date1 = new Date(dt1);
    const date2 = new Date(dt2);
    const diffTime = date2 - date1;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  datesAreEgual = (dt1, dt2) => {

    // console.log('dt1 :>> ', dt1);
    // console.log('dt2 :>> ', dt2);
    
    if(!dt1 || !dt2){return false;}

    return (
        dt1.getFullYear() === dt2.getFullYear() &&
        dt1.getMonth() === dt2.getMonth() &&
        dt1.getDate() === dt2.getDate()
    )
}

  formatareNumere = (
    nr,
    decimalSeparator = ".",
    groupingSeparator = " ",
    nrDecimals = 2
  ) => {
    let tx = String(Number(nr));
    let txSplited = tx.split(".");
    let left = txSplited.length > 0 ? txSplited[0] : tx;
    let right = txSplited.length > 1 ? txSplited[1] : "";
    // console.log("txSplited",txSplited)
    // console.log("tx",tx)

    let newLeft = [];
    for (let i = left.length - 1; i >= 0; i--) {
      newLeft.push(left.charAt(i));
      if (i < left.length - 1 && (left.length - i) % 3 == 0) {
        newLeft.push(groupingSeparator);
      }
    }

    let newRight = right.substring(0, nrDecimals);

    if (nrDecimals == 0 || newRight.length == 0) {
      return `${[...newLeft].reverse().join("")}`;
    }
    return `${[...newLeft].reverse().join("")}${decimalSeparator}${newRight}`;
  };
}
